module.exports = __webpack_public_path__ + "static/assets/99fec79011d9392d671f153c808772c2.svg";